import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b082bc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-address" }
const _hoisted_2 = {
  key: 0,
  class: "loding"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 0,
  class: "address-list"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Add New Address", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_loading = _resolveComponent("van-loading")!
  const _component_Address = _resolveComponent("Address")!
  const _component_ListEmpty = _resolveComponent("ListEmpty")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      title: "Shipping Address",
      skipPath: $setup.skipPath,
      backgroundColor: "#424040",
      fontColor: "#fff"
    }, null, 8, ["skipPath"]),
    ($setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_van_loading, { size: "46" })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($setup.address_list && $setup.address_list.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.address_list, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "address-item",
                    key: item.address_id
                  }, [
                    _createVNode(_component_Address, {
                      item: item,
                      onDelete_fn: $setup.delete_fn,
                      onEdit_fn: $setup.edit_fn
                    }, null, 8, ["item", "onDelete_fn", "onEdit_fn"])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_ListEmpty)
              ]))
        ])),
    _createElementVNode("div", {
      class: "add_address",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.jumpAddress && $setup.jumpAddress(...args)))
    }, [
      _createVNode(_component_van_icon, {
        name: "add-o",
        size: "20"
      }),
      _hoisted_6
    ])
  ]))
}